const MAX_CHARS = 60;
const suffix = process.env.NEXT_PUBLIC_PAGE_TITLE_SUFFIX;
const suffixChars = suffix?.length || 0;

export const pageTitle = (title: string): string => {
  return title.length <= MAX_CHARS - suffixChars ? `${title} - ${suffix}` : `${title}`;
};
